module.exports = __webpack_public_path__ + "img/w1b.0f32a084.jpg";